import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import SearchedContainerDetailsTableForScanners from './SearchedContainerDetailsTableForScanners';
import { SearchPages, setPageToRender } from 'src/store/common-slices/searchSlice';

const mapStateToProps = (state: RootState) => ({
    containerDetails: state.GetContainer.containerDetailsOutput
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    setPageToRender: (pageToRender: SearchPages) => dispatch(setPageToRender(pageToRender))
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchedContainerDetailsTableForScanners);
